<template>
    <div class="tooltip-icon-container">
        <div class="tooltip-icon">
            <div v-if="loading" class="loader">
                <ui-load-indicator bg-color="#C9C9E8" color="#0091FF" :h="20" :stroke="8" />
            </div>

            <div v-if="!loading && text" :class="['icon-group', size]">
                <em :class="icon" />

                <span :class="['tooltip', positionText]">
                    {{ text }}

                    <a v-if="link" :href="link" class="tooltip-link" target="_blank">
                        Saiba Mais
                        <em class="far fa-external-link" />
                    </a>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import { uiLoadIndicator } from '@/components/ui'

export default {
	name: 'ui-tooltip-icon',

	components: {
		uiLoadIndicator
	},

	props: {
		/**
		* Por padrão é utilizado o ícone de informação
		*/
		icon: {
			type: String,
			default: 'fal fa-info-circle'
		},

		/**
		* Texto do tooltip
		*/
		text: {
			type: String,
			default: ''
		},

		/**
		* Link externo para mais informações ao usuário
		*/
		link: {
			type: String,
			default: ''
		},

		/**
		* Loading caso precise aguardar informações necessárias
		*/
		loading: {
			type: Boolean,
			default: false
		},

		/**
		* Tamanho do ícone
		* Valores disponíveis: "sm", "md"
		*/
		size: {
			type: String,
			default: 'md'
		},

		/**
		* Posição do ícone
		* Valores disponíveis: 'top', 'bottom'
		*/
		positionText: {
			type: String,
			default: 'top'
		},
	},
}

</script>

<style lang="stylus" scoped>
	@import './styles.styl';

</style>
